export default {
  title: 'Nollaa salasana',
  description: 'Lähetämme salasanan nollauslinkin sähköpostiisi.',
  sent: 'Sähköposti lähetetty.',

  form: {
    email: {
      title: 'Sähköposti',
      placeholder: 'Anna sähköposti',
    },
    button: {
      title: 'Nollaa salasana',
    },
    error_messages: {
      error1: 'Puuttuvat tiedot',
    },
  },
};
